<template>
  <div class="basic-block block-advice" :style="styles">
    <img v-if="targetInfo.advice.deco" :src="targetInfo.advice.deco" class="block-advice__deco" alt="">
    <div class="content-wrap">
      <div class="block-advice__inner">
        <h2 class="block-advice__title">
          <span>あなたへのアドバイス</span>
          <lp-alphabet-advice color="#FFFBE3" />
        </h2>
        <img class="block-advice__img" :src="targetInfo.advice.counselorImage" alt="">
        <p class="block-advice__text">{{ resultData.text5 }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import LpAlphabetAdvice from '@/utvStore/components/recommend/lp/partials/LpAlphabetAdvice'

export default {
  name: 'BlockAdvice',
  components: {
    LpAlphabetAdvice,
  },
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    resultData: Object,
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-advice {
  background: $l_col_second;
  padding: 46px 0 60px;
  &__deco {
    position: absolute;
    top: -45px;
    left: 0;
    width: 17.6%;
    max-width: 80px;
    z-index: 101;
  }
  &__title {
    margin: 0 0 40px;
    font-weight: bold;
    font-size: 26px;
    line-height: 1;
    text-align: center;
    color: #fff;
    position: relative;
  }
  &__img {
    display: block;
    margin: 0 auto 16px;
    width: 170px;
  }
  &__text {
    font-weight: bold;
    font-size: 16px;
    line-height: 34px;
    text-align: justify;
    color: #FFFFFF;
    padding: 0 40px;
    margin: 0 auto;
    max-width: 480px;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      bottom: -23px;
      right: 20px;
      width: 44px;
      height: 63px;
      background: url('/static/img/recommend/lp/common/kira.png') no-repeat 0 0/cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/ottimo/blocks/BlockAdvice.vue